<template>
  <div>
    <b-container style="margin: 4em auto;">
      <b-row v-loading="loading">
        <div style="padding:5px 0px 5px 0px;margin:5px 0px 5px 0px;">
          <router-link to="/">
            <button type="button" class="btn btn-success">+ Yeni Ödeme</button>
          </router-link>
        </div>
        <div class="table-responsive">
          <table class="datatable table table-striped table-bordered">
            <thead>
              <tr>
                <th scope="col">Makbuz No</th>
                <th scope="col">Tarih/Saat</th>
                <th scope="col">Durum</th>
                <th scope="col">Ad Soyad</th>
                <th scope="col">Firma Adı</th>
                <th scope="col">Açıklama</th>
                <th scope="col">Tutar</th>
                <th scope="col">Eylemler</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,key) in data" :key="key">
                  <td>{{ item.id }}</td>
                  <td>{{ $moment(item.created_at).format('MM.DD.YYYY h:mm:ss') }}</td>
                  <td><span :class="'text text-' + (item.status == 1 ? 'success' : (item.status == 2 ? 'danger' : 'warning'))">{{ item.status_name }}</span></td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.company_name }}</td>
                  <td>{{ _.first(_.filter(item.fields, { 'name': 'note'})).value }}</td>
                  <td>{{ item.amount }}</td>
                  <td>
                    Göster
                  </td>
                </tr>
            </tbody>
            <tfoot>
              <tr style="background-color:#f0f7ff;">
                <th colspan="6">Toplamlar</th>
                <th style="text-align:right;">0 TL</th>
                <th></th>
              </tr>
            </tfoot>
            <div class="block pagination">
              <el-pagination
                  v-if="paginateFilter.pageTotal > 0"
                  @size-change="handleSizeChange"
                  @current-change="fetch"
                  :current-page.sync="paginateFilter.page"
                  :page-sizes="sizes"
                  :page-size="paginateFilter.size"
                  layout="sizes, prev, pager, next"
                  :total="paginateFilter.pageTotal"
              ></el-pagination>
            </div> 
          </table>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default{
    name: 'MyAccount',
    data(){
      return{
        sizes: [10, 20, 50, 100],
        loading:false,
        paginateFilter:{
          pageTotal: 0,
          size: 10,
          page: 1,
          types: []
        },
        data:[]
      }
    },
    watch:{
        "paginateFilter.types": function(val) {
          this.fetch(1, this.paginateFilter.size);
        },
    },
    created(){
      this.fetch();
    },
    methods:{
      handleSizeChange(value){
        this.paginateFilter.size = value;
        this.fetch();
      },
      fetch(page = 1, size = null, silent = false){
        this.paginateFilter.page = page;

        if (!_.isNull(size)) 
        {
            this.paginateFilter.size = size;
        }
        if(!silent) this.loading = true;
        axios.get('/account/transactions',{params: this.paginateFilter })
        .then((response) => {
          this.data = response.data.transactions.data;
          this.paginateFilter.pageTotal  	= response.data.transactions.total;
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },
    }
  }
</script>
